<template>
  <div class="app-ck-wrap">
    <label v-for="option in options" :key="option.value" class="app-radio-bk">
      <input type="radio" v-model="model" :value="option.value" />
      {{ option.label }}
    </label>
  </div>
</template>

<script setup lang="ts">
type Option = {
  label: string;
  value: number;
};

withDefaults(
  defineProps<{
    options: Option[];
  }>(),
  {
    options: () => [],
  }
);

const model = defineModel<number>({ default: 0 });
</script>

<style lang="scss" scoped></style>
